export const TIARA_PAGE = {
  ROOT: 'MYBIZ',
  DASHBOARD_DEALER: '대시보드_딜러사',
  DASHBOARD_PARTNER: '대시보드_이용기관',
  APP_REGISTER_INFO_REVIEW: '이용기관등록_등록정보확인',
  APP_REGISTER_CHANNEL_FORM: '이용기관등록_채널정보입력',
  APP_REGISTER_EMPTY_CHANNEL_FORM: '이용기관등록_채널정보입력',
  APP_REGISTER_APP_FORM: '이용기관등록_앱정보입력',
  SVC_LIST: '이용중인지갑상품보기',
  APP_REGISTER_COMPLETE: '등록신청완료',
  BIZ_APP_REGISTER_COMPLETE: '비즈앱전환_등록신청완료',
  APP_CREATE: '앱만들기',
  ACCOUNT: '내정보',
  ACCOUNT_LEAVE: '회원탈퇴',
  TERMS: '지갑파트너센터약관',
  EDOC_PARTNER: '전자문서_이용기관목록',
  EDOC_PARTNER_SVC: '전자문서_이용기관기관목록',
  EDOC_PARTNER_MEMBERS: '전자문서_이용기관멤버관리',
  PARTNER_MEMBER_INVITE: '멤버초대하기레이어',
  PARTNER_MEMBER_INVITATION_CANCEL_POPUP: '멤버초대취소팝업',
  PARTNER_MEMBER_ROLE_CHANGE_LAYER: '멤버권한변경레이어',
  PARTNER_MEMBER_DELETE_POPUP: '멤버삭제팝업',
  EDOC_SVC_ADD: '전자문서_기관추가',
  EDOC_SVC_DETAIL: '전자문서_기관상세',
  EDOC_SVC_EDIT: '전자문서_기관정보수정',
  EDOC_PARTNER_REGISTER: '전자문서_이용기관등록',
  EDOC_PARTNER_REGISTER_COMPLETE: '전자문서_이용기관등록완료',
  SET4_PARTNER: '인증서_이용기관목록',
  SET4_PARTNER_SVC: '인증서_이용기관기관목록',
  SET4_PARTNER_MEMBERS: '인증서_이용기관멤버관리',
  SET4_SVC_DETAIL: '인증서_기관상세',
  SET4_SVC_EDIT: '인증서_기관정보수정',
  SET4_PARTNER_REGISTER: '인증서_이용기관등록',
  SET4_PARTNER_REGISTER_COMPLETE: '인증서_이용기관등록완료',
  NEW_BUSINESS_REGISTER: '사업자정보신규등록',
  CI_SUBMISSION_GUIDE: 'CI보유여부근거자료제출가이드',
  MYDATA_PARTNER_SVC: '마이데이터_이용기관기관목록',
  MYDATA_SVC_DETAIL: '마이데이터_기관상세',
  MYDATA_SVC_EDIT: '마이데이터_기관정보수정',
  INFO_MEMBERS: '멤버관리',
  INFO_MEMBER_INVITATE: '멤버초대하기',
  INFO_MEMBER_INVITATION_CANCEL_POPUP: '멤버초대취소팝업',
  INFO_MEMBER_ROLE_CHANGE_LAYER: '멤버권한변경레이어',
  INFO_MEMBER_DELETE_POPUP: '멤버삭제팝업',
  BUSINESS_INFO: '사업자정보관리',
  MYDATA_BUSINESS_INFO: '마이데이터_사업자정보관리',
  DEALER_CONTRACT: '딜러계약조회',
  DEALER_SERVICE_PRICE: '서비스제공단가_딜러사',
  DIRECT_PARTNER_SERVICE_PRICE: '서비스제공단가_직접이용기관',
  SET4_CONTRACT_FOR_DEALER: '인증_이용기관계약조회_딜러사',
  EDOC_CONTRACT_FOR_DEALER: '전자문서_이용기관계약조회_딜러사',
  MYDATA_CONTRACT_FOR_DEALER: '마이데이터_이용기관계약조회_딜러사',
  SET4_CONTRACT_DETAIL_FOR_DEALER: '인증_계약정보상세조회_딜러사',
  EDOC_CONTRACT_DETAIL_FOR_DEALER: '전자문서_계약정보상세조회_딜러사',
  MYDATA_CONTRACT_DETAIL_FOR_DEALER: '마이데이터_계약정보상세조회_딜러사',
  SET4_CONTRACT_DETAIL_FOR_IN_DIRECT_PARTNER: '인증_계약정보상세조회_간접이용기관',
  EDOC_CONTRACT_DETAIL_FOR_IN_DIRECT_PARTNER: '전자문서_계약정보상세조회_간접이용기관',
  MYDATA_CONTRACT_DETAIL_FOR_IN_DIRECT_PARTNER: '마이데이터_계약정보상세조회_간접이용기관',
  SET4_CONTRACT_DETAIL_FOR_DIRECT_PARTNER: '인증_계약정보상세조회_직접이용기관',
  EDOC_CONTRACT_DETAIL_FOR_DIRECT_PARTNER: '전자문서_계약정보상세조회_직접이용기관',
  MYDATA_CONTRACT_DETAIL_FOR_DIRECT_PARTNER: '마이데이터_계약정보상세조회_직접이용기관',
  SET4_ADD_CONTRACT_FOR_DEALER: '인증_이용기관계약추가_딜러사',
  EDOC_ADD_CONTRACT_FOR_DEALER: '전자문서_이용기관계약추가_딜러사',
  MYDATA_ADD_CONTRACT_FOR_DEALER: '마이데이터_이용기관계약추가_딜러사',
  SET4_ADD_CONTRACT_FOR_DIRECT_PARTNER: '인증_계약추가_직접이용기관',
  EDOC_ADD_CONTRACT_FOR_DIRECT_PARTNER: '전자문서_계약추가_직접이용기관',
  MYDATA_ADD_CONTRACT_FOR_DIRECT_PARTNER: '마이데이터_계약추가_직접이용기관',
  EMAIL_RESEND_POPUP: '이메일재전송팝업',
  PARNTER_SELECT_POPUP: '이용기관선택팝업',
  EDOC_PRODUCT_SELECT_LAYER: '전자문서상품선택레이어',
  SETTLE_ID_ADD_POPUP: 'SettleID추가팝업',
  SETTLE_EDIT_POPUP: 'Settle정보수정팝업',
  SET4_CONTRACT_INQUIRY_IN_DIRECT_PARTNER: '인증_계약조회_간접이용기관',
  EDOC_CONTRACT_INQUIRY_IN_DIRECT_PARTNER: '전자문서_계약조회_간접이용기관',
  MYDATA_CONTRACT_INQUIRY_IN_DIRECT_PARTNER: '마이데이터_계약조회_간접이용기관',
  SET4_CONTRACT_INQUIRY_DIRECT_PARTNER: '인증_계약조회_직접이용기관',
  EDOC_CONTRACT_INQUIRY_DIRECT_PARTNER: '전자문서_계약조회_직접이용기관',
  MYDATA_CONTRACT_INQUIRY_DIRECT_PARTNER: '마이데이터_계약조회_직접이용기관',
  SET4_SETTLE_INVOICE_DEALER: '인증_정산내역_딜러사',
  EDOC_SETTLE_INVOICE_DEALER: '전자문서_정산내역_딜러사',
  MYDATA_SETTLE_INVOICE_DEALER: '마이데이터_정산내역_딜러사',
  SET4_SETTLE_INVOICE_DIRECT_PARTNER: '인증_정산내역_직접이용기관',
  EDOC_SETTLE_INVOICE_DIRECT_PARTNER: '전자문서_정산내역_직접이용기관',
  MYDATA_SETTLE_INVOICE_DIRECT_PARTNER: '마이데이터_정산내역_직접이용기관',
  SET4_SETTLE_INVOICE_DETAIL_DEALER: '인증_상세청구정보_딜러사',
  EDOC_SETTLE_INVOICE_DETAIL_DEALER: '전자문서_상세청구정보_딜러사',
  MYDATA_SETTLE_INVOICE_DETAIL_DEALER: '마이데이터_상세청구정보_딜러사',
  SET4_SETTLE_INVOICE_DETAIL_DIRECT_PARTNER: '인증_상세청구정보_직접이용기관',
  EDOC_SETTLE_INVOICE_DETAIL_DIRECT_PARTNER: '전자문서_상세청구정보_직접이용기관',
  MYDATA_SETTLE_INVOICE_DETAIL_DIRECT_PARTNER: '마이데이터_상세청구정보_직접이용기관',
  SET4_TAX_INVOICE_ISSUANCE_DEALER: '인증_세금계산서발행내역_딜러사',
  EDOC_TAX_INVOICE_ISSUANCE_DEALER: '전자문서_세금계산서발행내역_딜러사',
  MYDATA_TAX_INVOICE_ISSUANCE_DEALER: '마이데이터_세금계산서발행내역_딜러사',
  SET4_TAX_INVOICE_ISSUANCE_DIRECT_PARTNER: '인증_세금계산서발행내역_직접이용기관',
  EDOC_TAX_INVOICE_ISSUANCE_DIRECT_PARTNER: '전자문서_세금계산서발행내역_직접이용기관',
  MYDATA_TAX_INVOICE_ISSUANCE_DIRECT_PARTNER: '마이데이터_세금계산서발행내역_직접이용기관',
  SET4_SETTLE_BASE_INFO_DEALER: '인증_정산기본정보_딜러사',
  EDOC_SETTLE_BASE_INFO_DEALER: '전자문서_정산기본정보_딜러사',
  MYDATA_SETTLE_BASE_INFO_DEALER: '마이데이터_정산기본정보_딜러사',
  SET4_SETTLE_BASE_INFO_DIRECT_PARTNER: '인증_정산기본정보_직접이용기관',
  EDOC_SETTLE_BASE_INFO_DIRECT_PARTNER: '전자문서_정산기본정보_직접이용기관',
  MYDATA_SETTLE_BASE_INFO_DIRECT_PARTNER: '마이데이터_정산기본정보_직접이용기관',
  SET4_STATS_USAGE: '인증_사용량조회',
  EDOC_STATS_USAGE: '전자문서_사용량조회',
  MYDATA_STATS_USAGE: '마이데이터_사용량조회',
  SET4_STATS_REPORT_DEALER: '인증_통계리포트_딜러사',
  SET4_STATS_REPORT_DIRECT_PARTNER: '인증_통계리포트_직접이용기관',
  SET4_STATS_REPORT_IN_DIRECT_PARTNER: '인증_통계리포트_간접이용기관',
  EDOC_STATS_REPORT_DEALER: '전자문서_통계리포트_딜러사',
  EDOC_STATS_REPORT_DIRECT_PARTNER: '전자문서_통계리포트_직접이용기관',
  EDOC_STATS_REPORT_IN_DIRECT_PARTNER: '전자문서_통계리포트_간접이용기관'
} as const satisfies Record<string, string>;

export const TIARA_PAGE_CLICK = {
  SETTLE_INVOICE_EXCEL_DOWNLOAD: '정산내역액셀다운로드',
  TRANSACTION_STATEMENT_VIEW: '거래명세서보기',
  SETTLE_DATA_DOWNLOAD: '정산자료다운로드',
  SET4_SETTLE_STATUS_CHANGE_TO_ADJUSTMENT_REQUESTED_DEALER: '인증_정산상태조정요청변경_딜러사',
  EDOC_SETTLE_STATUS_CHANGE_TO_ADJUSTMENT_REQUESTED_DEALER: '전자문서_정산상태조정요청변경_딜러사',
  MYDATA_SETTLE_STATUS_CHANGE_TO_ADJUSTMENT_REQUESTED_DEALER: '마이데이터_정산상태조정요청변경_딜러사',
  SET4_SETTLE_STATUS_CHANGE_TO_CONFIRM_DEALER: '인증_정산상태확정변경_딜러사',
  EDOC_SETTLE_STATUS_CHANGE_TO_CONFIRM_DEALER: '전자문서_정산상태확정변경_딜러사',
  MYDATA_SETTLE_STATUS_CHANGE_TO_CONFIRM_DEALER: '마이데이터_정산상태확정변경_딜러사',
  SET4_SETTLE_STATUS_CHANGE_TO_ADJUSTMENT_REQUESTED_DIRECT_PARTNER: '인증_정산상태조정요청변경_직접이용기관',
  EDOC_SETTLE_STATUS_CHANGE_TO_ADJUSTMENT_REQUESTED_DIRECT_PARTNER: '전자문서_정산상태조정요청변경_직접이용기관',
  MYDATA_SETTLE_STATUS_CHANGE_TO_ADJUSTMENT_REQUESTED_DIRECT_PARTNER: '마이데이터_정산상태조정요청변경_직접이용기관',
  SET4_SETTLE_STATUS_CHANGE_TO_CONFIRM_DIRECT_PARTNER: '인증_정산상태확정변경_직접이용기관',
  EDOC_SETTLE_STATUS_CHANGE_TO_CONFIRM_DIRECT_PARTNER: '전자문서_정산상태확정변경_직접이용기관',
  MYDATA_SETTLE_STATUS_CHANGE_TO_CONFIRM_DIRECT_PARTNER: '마이데이터_정산상태확정변경_직접이용기관',
  ITEM_TITLE_CHANGE: '품목명변경',
  SETTLE_BASE_INFO_CHANGE: '정보수정하기',
  CONTRACT_EXCEL_DOWNLOAD: '계약내역엑셀다운로드',
  SET4_STATS_REPORT_DEALER: '인증_통계리포트_딜러사',
  SET4_STATS_REPORT_DIRECT_PARTNER: '인증_통계리포트_직접이용기관',
  SET4_STATS_REPORT_IN_DIRECT_PARTNER: '인증_통계리포트_간접이용기관',
  EDOC_STATS_REPORT_DEALER: '전자문서_통계리포트_딜러사',
  EDOC_STATS_REPORT_DIRECT_PARTNER: '전자문서_통계리포트_직접이용기관',
  EDOC_STATS_REPORT_IN_DIRECT_PARTNER: '전자문서_통계리포트_간접이용기관',
  DASHBOARD_STATS_REPORT_DEALER: '대시보드_통계리포트바로가기_딜러사',
  DASHBOARD_STATS_REPORT_PARTNER: '대시보드_통계리포트바로가기_이용기관'
} as const satisfies Record<string, string>;

const BASIC_TIARA_ACTION = Object.fromEntries(
  Object.entries(TIARA_PAGE).map(([key, value]) => [`${key}_VIEW`, `${value}_보기`])
) as Record<`${keyof typeof TIARA_PAGE}_VIEW`, string>;

const BASIC_TIARA_PAGE_CLICK = Object.fromEntries(
  Object.entries(TIARA_PAGE_CLICK).map(([key, value]) => [`${key}_CLICK`, `${value}_클릭`])
) as Record<`${keyof typeof TIARA_PAGE_CLICK}_CLICK`, string>;

export const TIARA_ACTION = {
  // 보기
  ...BASIC_TIARA_ACTION,

  // 보기 (이름의 형태가 다른 경우)
  APP_REGISTER_CHANNEL_FORM_VIEW: '채널조회_보기',
  APP_REGISTER_EMPTY_CHANNEL_FORM_VIEW: '채널개설_보기',

  // 클릭
  ...BASIC_TIARA_PAGE_CLICK,

  // 클릭 (data 속성을 쓰거나 이름의 형태가 다른 경우)
  SWITCH_BIZ_CHANNEL_CLICK: '비즈채널전환_클릭',
  REGISTER_BIZ_CHANNEL_CLICK: '채널정보등록_클릭',
  MAKE_NEW_CHANNEL_CLICK: '새채널만들기_클릭',
  USE_SELECTED_APP_CLICK: '선택한앱사용하기_클릭',
  APP_CREATE_CLICK: '앱만들기_클릭',
  SETTLE_INVOICE_EXCEL_DOWNLOAD_CLICK: '정산자료다운로드_클릭',
  SET4_STATS_USAGE_EXCEL_DOWNLOAD_CLICK: '인증_엑셀다운로드_클릭',
  EDOC_STATS_USAGE_EXCEL_DOWNLOAD_CLICK: '전자문서_엑셀다운로드_클릭',
  MYDATA_STATS_USAGE_EXCEL_DOWNLOAD_CLICK: '마이데이터_엑셀다운로드_클릭',
  SET4_SERVICE_CONTRACT_STATUS_CLICK: '인증_신규활성기관수_기관별계약현황보기_딜러사_클릭',
  SET4_SERVICE_CONTRACT_REQUEST_CLICK: '인증_서명요청기관수_기관별요청현황보기_딜러사_클릭',
  EDOC_SERVICE_CONTRACT_STATUS_CLICK: '전자문서_신규활성기관수_기관별계약현황보기_딜러사_클릭',
  EDOC_SERVICE_CONTRACT_REQUEST_CLICK: '전자문서_문서발송기관수_기관별요청현황보기_딜러사_클릭',
  SET4_SERVICE_INTRODUCE_CLICK: '인증_서비스소개서_딜러사_클릭',
  EDOC_SERVICE_INTRODUCE_CLICK: '전자문서_서비스소개서_딜러사_클릭',
  SET4_STATS_REPORT_WEEK_DEALER_CLICK: '인증_통계리포트_주간_딜러사_클릭',
  SET4_STATS_REPORT_MONTH_DEALER_CLICK: '인증_통계리포트_월간_딜러사_클릭',
  SET4_STATS_REPORT_YEAR_DEALER_CLICK: '인증_통계리포트_연간_딜러사_클릭',
  SET4_STATS_REPORT_WEEK_DIRECT_PARTNER_CLICK: '인증_통계리포트_주간_직접이용기관_클릭',
  SET4_STATS_REPORT_MONTH_DIRECT_PARTNER_CLICK: '인증_통계리포트_월간_직접이용기관_클릭',
  SET4_STATS_REPORT_YEAR_DIRECT_PARTNER_CLICK: '인증_통계리포트_연간_직접이용기관_클릭',
  SET4_STATS_REPORT_WEEK_IN_DIRECT_PARTNER_CLICK: '인증_통계리포트_주간_간접이용기관_클릭',
  SET4_STATS_REPORT_MONTH_IN_DIRECT_PARTNER_CLICK: '인증_통계리포트_월간_간접이용기관_클릭',
  SET4_STATS_REPORT_YEAR_IN_DIRECT_PARTNER_CLICK: '인증_통계리포트_연간_간접이용기관_클릭',
  EDOC_STATS_REPORT_WEEK_DEALER_CLICK: '전자문서_통계리포트_주간_딜러사_클릭',
  EDOC_STATS_REPORT_MONTH_DEALER_CLICK: '전자문서_통계리포트_월간_딜러사_클릭',
  EDOC_STATS_REPORT_YEAR_DEALER_CLICK: '전자문서_통계리포트_연간_딜러사_클릭',
  EDOC_STATS_REPORT_WEEK_DIRECT_PARTNER_CLICK: '전자문서_통계리포트_주간_직접이용기관_클릭',
  EDOC_STATS_REPORT_MONTH_DIRECT_PARTNER_CLICK: '전자문서_통계리포트_월간_직접이용기관_클릭',
  EDOC_STATS_REPORT_YEAR_DIRECT_PARTNER_CLICK: '전자문서_통계리포트_연간_직접이용기관_클릭',
  EDOC_STATS_REPORT_WEEK_IN_DIRECT_PARTNER_CLICK: '전자문서_통계리포트_주간_간접이용기관_클릭',
  EDOC_STATS_REPORT_MONTH_IN_DIRECT_PARTNER_CLICK: '전자문서_통계리포트_월간_간접이용기관_클릭',
  EDOC_STATS_REPORT_YEAR_IN_DIRECT_PARTNER_CLICK: '전자문서_통계리포트_연간_간접이용기관_클릭',
  SET4_STATS_REPORT_WEEK_DEALER_PERIOD_CLICK: '인증_통계리포트_주간_기간설정확인_딜러사_클릭',
  SET4_STATS_REPORT_MONTH_DEALER_PERIOD_CLICK: '인증_통계리포트_월간_기간설정확인_딜러사_클릭',
  SET4_STATS_REPORT_YEAR_DEALER_PERIOD_CLICK: '인증_통계리포트_연간_기간설정확인_딜러사_클릭',
  SET4_STATS_REPORT_WEEK_DIRECT_PARTNER_PERIOD_CLICK: '인증_통계리포트_주간_기간설정확인_직접이용기관_클릭',
  SET4_STATS_REPORT_MONTH_DIRECT_PARTNER_PERIOD_CLICK: '인증_통계리포트_월간_기간설정확인_직접이용기관_클릭',
  SET4_STATS_REPORT_YEAR_DIRECT_PARTNER_PERIOD_CLICK: '인증_통계리포트_연간_기간설정확인_직접이용기관_클릭',
  SET4_STATS_REPORT_WEEK_IN_DIRECT_PARTNER_PERIOD_CLICK: '인증_통계리포트_주간_기간설정확인_간접이용기관_클릭',
  SET4_STATS_REPORT_MONTH_IN_DIRECT_PARTNER_PERIOD_CLICK: '인증_통계리포트_월간_기간설정확인_간접이용기관_클릭',
  SET4_STATS_REPORT_YEAR_IN_DIRECT_PARTNER_PERIOD_CLICK: '인증_통계리포트_연간_기간설정확인_간접이용기관_클릭',
  EDOC_STATS_REPORT_WEEK_DEALER_PERIOD_CLICK: '전자문서_통계리포트_주간_기간설정확인_딜러사_클릭',
  EDOC_STATS_REPORT_MONTH_DEALER_PERIOD_CLICK: '전자문서_통계리포트_월간_기간설정확인_딜러사_클릭',
  EDOC_STATS_REPORT_YEAR_DEALER_PERIOD_CLICK: '전자문서_통계리포트_연간_기간설정확인_딜러사_클릭',
  EDOC_STATS_REPORT_WEEK_DIRECT_PARTNER_PERIOD_CLICK: '전자문서_통계리포트_주간_기간설정확인_직접이용기관_클릭',
  EDOC_STATS_REPORT_MONTH_DIRECT_PARTNER_PERIOD_CLICK: '전자문서_통계리포트_월간_기간설정확인_직접이용기관_클릭',
  EDOC_STATS_REPORT_YEAR_DIRECT_PARTNER_PERIOD_CLICK: '전자문서_통계리포트_연간_기간설정확인_직접이용기관_클릭',
  EDOC_STATS_REPORT_WEEK_IN_DIRECT_PARTNER_PERIOD_CLICK: '전자문서_통계리포트_주간_기간설정확인_간접이용기관_클릭',
  EDOC_STATS_REPORT_MONTH_IN_DIRECT_PARTNER_PERIOD_CLICK: '전자문서_통계리포트_월간_기간설정확인_간접이용기관_클릭',
  EDOC_STATS_REPORT_YEAR_IN_DIRECT_PARTNER_PERIOD_CLICK: '전자문서_통계리포트_연간_기간설정확인_간접이용기관_클릭',
  SET4_REQUEST_RANK_DETAIL_DEALER_CLICK: '인증_서명요청순위_상세_딜러사_클릭',
  SET4_REQUEST_RANK_HIGH_DEALER_CLICK: '인증_서명요청순위_높은순_딜러사_클릭',
  SET4_REQUEST_RANK_LOW_DEALER_CLICK: '인증_서명요청순위_낮은순_딜러사_클릭',
  SET4_USAGE_STATUS_SVC_DEALER_CLICK: '인증_기관별서명요청현황_기관명_딜러사_클릭',
  SET4_USAGE_STATUS_USAGE_DEALER_CLICK: '인증_기관별서명요청현황_사용량조회_딜러사_클릭',
  SET4_USAGE_STATUS_SVC_DIRECT_PARTNER_CLICK: '인증_서명요청현황_기관명_직접이용기관_클릭',
  SET4_USAGE_STATUS_USAGE_DIRECT_PARTNER_CLICK: '인증_서명요청현황_사용량조회_직접이용기관_클릭',
  SET4_USAGE_STATUS_SVC_INDIRECT_PARTNER_CLICK: '인증_서명요청현황_기관명_간접이용기관_클릭',
  SET4_USAGE_STATUS_USAGE_INDIRECT_PARTNER_CLICK: '인증_서명요청현황_사용량조회_간접이용기관_클릭',
  EDOC_REQUEST_RANK_DETAIL_DEALER_CLICK: '전자문서_문서발송순위_상세_딜러사_클릭',
  EDOC_REQUEST_RANK_HIGH_DEALER_CLICK: '전자문서_문서발송순위_높은순_딜러사_클릭',
  EDOC_REQUEST_RANK_LOW_DEALER_CLICK: '전자문서_문서발송순위_낮은순_딜러사_클릭',
  EDOC_USAGE_STATUS_SVC_DEALER_CLICK: '전자문서_기관별문서발송현황_기관명_딜러사_클릭',
  EDOC_USAGE_STATUS_USAGE_DEALER_CLICK: '전자문서_기관별문서발송현황_사용량조회_딜러사_클릭',
  EDOC_USAGE_STATUS_SVC_DIRECT_PARTNER_CLICK: '전자문서_문서발송현황_기관명_직접이용기관_클릭',
  EDOC_USAGE_STATUS_USAGE_DIRECT_PARTNER_CLICK: '전자문서_문서발송현황_사용량조회_직접이용기관_클릭',
  EDOC_USAGE_STATUS_SVC_INDIRECT_PARTNER_CLICK: '전자문서_문서발송현황_기관명_간접이용기관_클릭',
  EDOC_USAGE_STATUS_USAGE_INDIRECT_PARTNER_CLICK: '전자문서_문서발송현황_사용량조회_간접이용기관_클릭',
  EDOC_MESSAGE_COMPOSITION_DEALER_CLICK: '전자문서_문서열람순위_열람률을높이는메시지구성_딜러사_클릭',
  EDOC_MESSAGE_COMPOSITION_DIRECT_PARTNER_CLICK: '전자문서_문서열람순위_열람률을높이는메시지구성_직접이용기관_클릭',
  EDOC_MESSAGE_COMPOSITION_INDIRECT_PARTNER_CLICK: '전자문서_문서열람순위_열람률을높이는메시지구성_간접이용기관_클릭'
} as const satisfies Record<string, string>;

export const TIARA_SECTION = {
  HOME: '홈',
  PARTNER: '이용기관관리',
  INFO: '정보관리',
  CONTRACT: '계약관리',
  SETTLE: '정산관리',
  STATS: '통계',
  ETC: '기타'
} as const satisfies Record<string, string>;

export const TIARA_SECTION_BY_PAGE_KEY = {
  ROOT: TIARA_SECTION.HOME,
  DASHBOARD_DEALER: TIARA_SECTION.HOME,
  DASHBOARD_PARTNER: TIARA_SECTION.HOME,
  APP_REGISTER_INFO_REVIEW: TIARA_SECTION.HOME,
  APP_REGISTER_CHANNEL_FORM: TIARA_SECTION.HOME,
  APP_REGISTER_EMPTY_CHANNEL_FORM: TIARA_SECTION.HOME,
  APP_REGISTER_APP_FORM: TIARA_SECTION.HOME,
  SVC_LIST: TIARA_SECTION.HOME,
  APP_REGISTER_COMPLETE: TIARA_SECTION.HOME,
  BIZ_APP_REGISTER_COMPLETE: TIARA_SECTION.HOME,
  APP_CREATE: TIARA_SECTION.HOME,
  ACCOUNT: TIARA_SECTION.ETC,
  ACCOUNT_LEAVE: TIARA_SECTION.ETC,
  TERMS: TIARA_SECTION.ETC,
  EDOC_PARTNER: TIARA_SECTION.PARTNER,
  EDOC_PARTNER_SVC: TIARA_SECTION.PARTNER,
  EDOC_PARTNER_MEMBERS: TIARA_SECTION.PARTNER,
  PARTNER_MEMBER_INVITE: TIARA_SECTION.PARTNER,
  PARTNER_MEMBER_INVITATION_CANCEL_POPUP: TIARA_SECTION.PARTNER,
  PARTNER_MEMBER_ROLE_CHANGE_LAYER: TIARA_SECTION.PARTNER,
  PARTNER_MEMBER_DELETE_POPUP: TIARA_SECTION.PARTNER,
  EDOC_SVC_ADD: TIARA_SECTION.PARTNER,
  EDOC_SVC_DETAIL: TIARA_SECTION.PARTNER,
  EDOC_SVC_EDIT: TIARA_SECTION.PARTNER,
  EDOC_PARTNER_REGISTER: TIARA_SECTION.PARTNER,
  EDOC_PARTNER_REGISTER_COMPLETE: TIARA_SECTION.PARTNER,
  SET4_PARTNER: TIARA_SECTION.PARTNER,
  SET4_PARTNER_SVC: TIARA_SECTION.PARTNER,
  SET4_PARTNER_MEMBERS: TIARA_SECTION.PARTNER,
  SET4_SVC_DETAIL: TIARA_SECTION.PARTNER,
  SET4_SVC_EDIT: TIARA_SECTION.PARTNER,
  SET4_PARTNER_REGISTER: TIARA_SECTION.PARTNER,
  SET4_PARTNER_REGISTER_COMPLETE: TIARA_SECTION.PARTNER,
  NEW_BUSINESS_REGISTER: TIARA_SECTION.PARTNER,
  CI_SUBMISSION_GUIDE: TIARA_SECTION.PARTNER,
  MYDATA_PARTNER_SVC: TIARA_SECTION.PARTNER,
  MYDATA_SVC_DETAIL: TIARA_SECTION.PARTNER,
  MYDATA_SVC_EDIT: TIARA_SECTION.PARTNER,
  INFO_MEMBERS: TIARA_SECTION.INFO,
  INFO_MEMBER_INVITATE: TIARA_SECTION.INFO,
  INFO_MEMBER_INVITATION_CANCEL_POPUP: TIARA_SECTION.INFO,
  INFO_MEMBER_ROLE_CHANGE_LAYER: TIARA_SECTION.INFO,
  INFO_MEMBER_DELETE_POPUP: TIARA_SECTION.INFO,
  BUSINESS_INFO: TIARA_SECTION.INFO,
  MYDATA_BUSINESS_INFO: TIARA_SECTION.INFO,
  DEALER_CONTRACT: TIARA_SECTION.CONTRACT,
  DEALER_SERVICE_PRICE: TIARA_SECTION.CONTRACT,
  DIRECT_PARTNER_SERVICE_PRICE: TIARA_SECTION.CONTRACT,
  SET4_CONTRACT_FOR_DEALER: TIARA_SECTION.CONTRACT,
  EDOC_CONTRACT_FOR_DEALER: TIARA_SECTION.CONTRACT,
  MYDATA_CONTRACT_FOR_DEALER: TIARA_SECTION.CONTRACT,
  SET4_CONTRACT_DETAIL_FOR_DEALER: TIARA_SECTION.CONTRACT,
  EDOC_CONTRACT_DETAIL_FOR_DEALER: TIARA_SECTION.CONTRACT,
  MYDATA_CONTRACT_DETAIL_FOR_DEALER: TIARA_SECTION.CONTRACT,
  SET4_CONTRACT_DETAIL_FOR_IN_DIRECT_PARTNER: TIARA_SECTION.CONTRACT,
  EDOC_CONTRACT_DETAIL_FOR_IN_DIRECT_PARTNER: TIARA_SECTION.CONTRACT,
  MYDATA_CONTRACT_DETAIL_FOR_IN_DIRECT_PARTNER: TIARA_SECTION.CONTRACT,
  SET4_CONTRACT_DETAIL_FOR_DIRECT_PARTNER: TIARA_SECTION.CONTRACT,
  EDOC_CONTRACT_DETAIL_FOR_DIRECT_PARTNER: TIARA_SECTION.CONTRACT,
  MYDATA_CONTRACT_DETAIL_FOR_DIRECT_PARTNER: TIARA_SECTION.CONTRACT,
  SET4_ADD_CONTRACT_FOR_DEALER: TIARA_SECTION.CONTRACT,
  EDOC_ADD_CONTRACT_FOR_DEALER: TIARA_SECTION.CONTRACT,
  MYDATA_ADD_CONTRACT_FOR_DEALER: TIARA_SECTION.CONTRACT,
  SET4_ADD_CONTRACT_FOR_DIRECT_PARTNER: TIARA_SECTION.CONTRACT,
  EDOC_ADD_CONTRACT_FOR_DIRECT_PARTNER: TIARA_SECTION.CONTRACT,
  MYDATA_ADD_CONTRACT_FOR_DIRECT_PARTNER: TIARA_SECTION.CONTRACT,
  EMAIL_RESEND_POPUP: TIARA_SECTION.CONTRACT,
  PARNTER_SELECT_POPUP: TIARA_SECTION.CONTRACT,
  EDOC_PRODUCT_SELECT_LAYER: TIARA_SECTION.CONTRACT,
  SETTLE_ID_ADD_POPUP: TIARA_SECTION.CONTRACT,
  SETTLE_EDIT_POPUP: TIARA_SECTION.CONTRACT,
  SET4_CONTRACT_INQUIRY_IN_DIRECT_PARTNER: TIARA_SECTION.CONTRACT,
  EDOC_CONTRACT_INQUIRY_IN_DIRECT_PARTNER: TIARA_SECTION.CONTRACT,
  MYDATA_CONTRACT_INQUIRY_IN_DIRECT_PARTNER: TIARA_SECTION.CONTRACT,
  SET4_CONTRACT_INQUIRY_DIRECT_PARTNER: TIARA_SECTION.CONTRACT,
  EDOC_CONTRACT_INQUIRY_DIRECT_PARTNER: TIARA_SECTION.CONTRACT,
  MYDATA_CONTRACT_INQUIRY_DIRECT_PARTNER: TIARA_SECTION.CONTRACT,
  SET4_SETTLE_INVOICE_DEALER: TIARA_SECTION.SETTLE,
  EDOC_SETTLE_INVOICE_DEALER: TIARA_SECTION.SETTLE,
  MYDATA_SETTLE_INVOICE_DEALER: TIARA_SECTION.SETTLE,
  SET4_SETTLE_INVOICE_DIRECT_PARTNER: TIARA_SECTION.SETTLE,
  EDOC_SETTLE_INVOICE_DIRECT_PARTNER: TIARA_SECTION.SETTLE,
  MYDATA_SETTLE_INVOICE_DIRECT_PARTNER: TIARA_SECTION.SETTLE,
  SET4_SETTLE_INVOICE_DETAIL_DEALER: TIARA_SECTION.SETTLE,
  EDOC_SETTLE_INVOICE_DETAIL_DEALER: TIARA_SECTION.SETTLE,
  MYDATA_SETTLE_INVOICE_DETAIL_DEALER: TIARA_SECTION.SETTLE,
  SET4_SETTLE_INVOICE_DETAIL_DIRECT_PARTNER: TIARA_SECTION.SETTLE,
  EDOC_SETTLE_INVOICE_DETAIL_DIRECT_PARTNER: TIARA_SECTION.SETTLE,
  MYDATA_SETTLE_INVOICE_DETAIL_DIRECT_PARTNER: TIARA_SECTION.SETTLE,
  SET4_TAX_INVOICE_ISSUANCE_DEALER: TIARA_SECTION.SETTLE,
  EDOC_TAX_INVOICE_ISSUANCE_DEALER: TIARA_SECTION.SETTLE,
  MYDATA_TAX_INVOICE_ISSUANCE_DEALER: TIARA_SECTION.SETTLE,
  SET4_TAX_INVOICE_ISSUANCE_DIRECT_PARTNER: TIARA_SECTION.SETTLE,
  EDOC_TAX_INVOICE_ISSUANCE_DIRECT_PARTNER: TIARA_SECTION.SETTLE,
  MYDATA_TAX_INVOICE_ISSUANCE_DIRECT_PARTNER: TIARA_SECTION.SETTLE,
  SET4_SETTLE_BASE_INFO_DEALER: TIARA_SECTION.SETTLE,
  EDOC_SETTLE_BASE_INFO_DEALER: TIARA_SECTION.SETTLE,
  MYDATA_SETTLE_BASE_INFO_DEALER: TIARA_SECTION.SETTLE,
  SET4_SETTLE_BASE_INFO_DIRECT_PARTNER: TIARA_SECTION.SETTLE,
  EDOC_SETTLE_BASE_INFO_DIRECT_PARTNER: TIARA_SECTION.SETTLE,
  MYDATA_SETTLE_BASE_INFO_DIRECT_PARTNER: TIARA_SECTION.SETTLE,
  SET4_STATS_USAGE: TIARA_SECTION.STATS,
  EDOC_STATS_USAGE: TIARA_SECTION.STATS,
  MYDATA_STATS_USAGE: TIARA_SECTION.STATS,
  SET4_STATS_REPORT_DEALER: TIARA_SECTION.STATS,
  SET4_STATS_REPORT_DIRECT_PARTNER: TIARA_SECTION.STATS,
  SET4_STATS_REPORT_IN_DIRECT_PARTNER: TIARA_SECTION.STATS,
  EDOC_STATS_REPORT_DEALER: TIARA_SECTION.STATS,
  EDOC_STATS_REPORT_DIRECT_PARTNER: TIARA_SECTION.STATS,
  EDOC_STATS_REPORT_IN_DIRECT_PARTNER: TIARA_SECTION.STATS
} satisfies Record<TiaraPageKey, TiaraSection>;

export type TiaraPageKey = keyof typeof TIARA_PAGE;
export type TiaraPageClickKey = keyof typeof TIARA_PAGE_CLICK;
export type TiaraActionKey = keyof typeof TIARA_ACTION;
export type TiaraSectionKey = keyof typeof TIARA_SECTION;

export type TiaraPage = (typeof TIARA_PAGE)[TiaraPageKey];
export type TiaraPageClick = (typeof TIARA_PAGE_CLICK)[TiaraPageClickKey];
export type TiaraAction = (typeof TIARA_ACTION)[TiaraActionKey];
export type TiaraSection = (typeof TIARA_SECTION)[TiaraSectionKey];
